import { BaseDataService } from "../../../services/base/BaseDataService";
import { Workflow } from "../models/Workflow";
import { WorkflowQuery } from "../models/WorkflowQuery";


export class WorkflowService extends BaseDataService<Workflow, WorkflowQuery> {
  protected prefixUrl: string = `Workflows`;
}
